export default class ValidationError extends Error {
  constructor(message, propertyName) {
    super(message);
    this.propertyName = propertyName;
  }
}
